"use strict";

import { ofType } from "redux-observable";
import { switchMap, mergeMap, catchError, map, of, from } from "rxjs";
import { ajax } from "rxjs/ajax";

import { insightConstants, requestTypes } from "../_constants";
import {
    insightLiveboardListComplete,
    ajaxError,
    insightsGetJobRoleAndCountListCompleted,
    insightGetDealersSummaryCompleted,
    sherbotGetAIInstructionComplete,
    sherbotGetAIInstructionError,
    sherbotUpdateAIInstructionComplete,
    sherbotUpdateAIInstructionError,
} from "../_actions";
import { getRequestHeader } from "../../_helpers/request.header";

import { getThoughtSpotClient } from "../../config/thoughtspot-config";

export const insightLiveboardEpic = (action$) => {
    const thoughtspotClient = getThoughtSpotClient();

    return action$.pipe(
        ofType(insightConstants.INSIGHT_GET_LIST_OF_LIVEBOARD_REQUEST),
        switchMap(({ payload }) => {
            return from(
                thoughtspotClient.searchMetadata({
                    ...payload,
                }),
            ).pipe(
                map((response) => {
                    return insightLiveboardListComplete({
                        data: response,
                    });
                }),

                catchError((error) => of(ajaxError(error))),
            );
        }),
    );
};

export const insightParticipantJobRoleAndCountEpic = (action$) => {
    const thoughtspotClient = getThoughtSpotClient();

    return action$.pipe(
        ofType(
            insightConstants.INSIGHT_GET_LIST_OF_JOB_ROLES_AND_COUNT_REQUEST,
        ),
        switchMap(({ payload }) => {
            return from(
                thoughtspotClient.fetchAnswerData({
                    ...payload,
                }),
            ).pipe(
                map((response) => {
                    const dataRows = response.contents[0].data_rows;

                    return insightsGetJobRoleAndCountListCompleted({
                        data: dataRows,
                    });
                }),

                catchError((error) => of(ajaxError(error))),
            );
        }),
    );
};

export const insightDealersSummaryStatEpic = (action$) => {
    const thoughtspotClient = getThoughtSpotClient();

    return action$.pipe(
        ofType(insightConstants.INSIGHT_GET_DEALERS_SUMMARY_REQUEST),
        switchMap(({ payload }) => {
            return from(
                thoughtspotClient.fetchAnswerData({
                    ...payload,
                }),
            ).pipe(
                map((response) => {
                    // Extract column names and first data row
                    const columnNames = response.contents[0].column_names;
                    const dataRow = response.contents[0].data_rows[0];

                    // transformed format
                    const result = columnNames.map((col, index) => [
                        col,
                        dataRow[index],
                    ]);

                    return insightGetDealersSummaryCompleted({
                        data: result,
                    });
                }),

                catchError((error) => of(ajaxError(error))),
            );
        }),
    );
};

export const sherbotAIInstructionsEpic = (action$) => {
    const thoughtspotClient = getThoughtSpotClient();

    return action$.pipe(
        ofType(insightConstants.SHERBOT_GET_AI_INSTRUCTION_REQUEST),
        switchMap(({ payload }) => {
            return from(
                thoughtspotClient.getNLInstructions({
                    ...payload,
                }),
            ).pipe(
                map((response) => {
                    return sherbotGetAIInstructionComplete({
                        data: response,
                    });
                }),

                catchError((error) =>
                    of(
                        sherbotGetAIInstructionError({
                            error: "Failed to load the Sherbot Instruction",
                        }),
                    ),
                ),
            );
        }),
    );
};

export const sherbotAIInstructionUpdateEpic = (action$) => {
    const thoughtspotClient = getThoughtSpotClient();

    return action$.pipe(
        ofType(insightConstants.SHERBOT_UPDATE_AI_INSTRUCTION_REQUEST),
        switchMap(({ payload }) => {
            return from(
                thoughtspotClient.setNLInstructions({
                    ...payload,
                }),
            ).pipe(
                map((response) => {
                    return sherbotUpdateAIInstructionComplete({
                        data: response,
                    });
                }),

                catchError((error) => {
                    return of(
                        sherbotUpdateAIInstructionError({
                            error: "Failed to update the Sherbot Instruction",
                        }),
                    );
                }),
            );
        }),
    );
};
